import axios from 'axios'
import Tariff from '@/dto/deliveries/Tariff'

const TariffsService = {
  getTariffs(
    deliveryId: number
  ): Promise<{
    tariffs: Tariff[]
    zoneNames: { [key: string]: string }
  }> {
    return axios
      .get(`/admin/deliveries/${deliveryId}/rates`)
      .then(response => ({
        tariffs: response.data.rates,
        zoneNames: response.data.zoneNames,
      }))
  },

  saveTariffs(deliveryId: number, tariffs: Tariff[]): Promise<Tariff[]> {
    return axios
      .put(`/admin/deliveries/${deliveryId}/rates`, { rates: tariffs })
      .then(response => response.data.rates)
  },
}

export default TariffsService
